<template>
    <div class="facets-kpi-type-1">
        <div v-for="(item, index) in buckets" :key="index" :class="[item.color ? 'has-color' : 'has-no-color']" :style="item.color ? { backgroundColor: '#' + item.color } : {}">
            <div v-if="item.icon" :class="`icon-${item.icon}-neg icon-m`"></div>
            <div class="value">{{ formatNumber(item.count) }}</div>
        
            <div class="h6 name" v-if="slug === 'province'">{{$t('common.located_in_1')}} {{item.displayName}}</div>
            <div class="h6 name" v-else-if="slug === 'apps'">{{$t('common.includes_1')}} {{formatDisplayText($t(`components.dataset_specification.apps.options.${item.val.replaceAll(' ', '_')}`))}}</div>
            <div class="h6 name" v-else-if="slug === 'socials'">{{$t('common.includes_1')}} {{$t(`common.${item.displayName || item.val}`)}}</div>
            <div class="h6 name" v-else>{{$t('common.includes_1')}} {{formatDisplayText(item.displayName || $t(`common.${item.val}`))}}</div>
        </div>
    </div>
</template>

<script>
    import { formatNumber } from '@/utils/formatting';
    export default {
        name: 'FacetsKpi',
        props: {
            buckets: {
                type: Array,
                required: true
            },
            slug: {
                type: String,
                required: false
            }
        },
        methods: {
            formatNumber,
            formatDisplayText(text) {
                if (!text || typeof text !== 'string' || text.length < 2) {
                    return text;
                }

                if (text.startsWith('KvK') || text.startsWith('CoC')) {
                    return text;
                }
                
                if (text[0] === text[0].toUpperCase() && (text[1] === '-' || text[1] !== text[1].toUpperCase())) {
                    return text.charAt(0).toLowerCase() + text.slice(1);
                }
                
                return text;
            }
        }
    }
</script>